import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c0a711d4&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=c0a711d4&scoped=true&lang=sass&"
import style1 from "./index.vue?vue&type=style&index=1&id=c0a711d4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0a711d4",
  null
  
)

export default component.exports